// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3EsZO","colMin":"styles_colMin__18tky","colCheckbox":"styles_colCheckbox__2wKfk"};